import {
  initialState,
  Actions,
  State,
  GET_GROUP_LAST_ACTIVITY,
  GET_GROUP_LAST_ACTIVITY_SUCCESS,
  GET_GROUP_LAST_ACTIVITY_ERROR,
  RESET_GET_GROUP_LAST_ACTIVITY,
} from "../../types/group/get-group-last-activity";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_GROUP_LAST_ACTIVITY:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_GROUP_LAST_ACTIVITY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_GROUP_LAST_ACTIVITY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: true,
          success: false,
        },
      };
    case RESET_GET_GROUP_LAST_ACTIVITY:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
